module.exports = __webpack_public_path__ + "static/media/logo.1931378f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 576
// module chunks = 17